import store from '@/store'
import { UserInformationResponse } from '@/types/service-response'
import { UiLanguageItem } from '@/types'

export class CurrentUser {
  private constructor (
    readonly id: number,
    readonly firstName: string,
    readonly lastName: string,
    readonly initials: string,
    readonly uiLanguage: UiLanguageItem,
    readonly function2: string,
    readonly department: string,
    readonly securityRole: string,
    readonly accessToken: string,
    readonly tokenType: string,
    private readonly _profilePicture: string,
    readonly changePassword: boolean,
    readonly dispositionDefaultDistance: number,
    readonly dragAndDrop: boolean,
    readonly resize: boolean,
    readonly addressResponsibility: number,
    readonly defaultProfitCenter: number | null,
    readonly defaultDepartment: number | null,
    readonly isAbsenceApprove: boolean,
    readonly planungAufProjekt: boolean,
    readonly defWebreportTemplate: string,
    readonly lohnIntegration: boolean
  ) {}

  get fullName (): string {
    return `${this.firstName} ${this.lastName}`
  }

  get profilePicture (): string {
    return this._profilePicture.includes('Default')
      ? require('@/assets/default-avatar.jpg') : this._profilePicture
  }

  get authorizationHeaderValue (): string {
    return `${this.tokenType}  ${this.accessToken}`
  }

  static createFromUserInformationResponse (responseData: UserInformationResponse): CurrentUser {
    const defaultUiLanguage = store.state.defaultUiLanguage

    const uiLanguageItem = store.state.uiLanguageList
      .filter((item: UiLanguageItem) => item.title.toLocaleLowerCase() === responseData.uiLanguageName.toLocaleLowerCase())
      .pop() || defaultUiLanguage

    return new CurrentUser(
      responseData.id!,
      responseData.firstName,
      responseData.lastName,
      responseData.initials,
      uiLanguageItem,
      responseData.function,
      responseData.department,
      responseData.securityRole,
      responseData.authToken.accessToken,
      responseData.authToken.tokenType,
      responseData.profilePicture,
      responseData.changePassword,
      responseData.STD_Umkreis,
      responseData.DragDrop,
      responseData.Resize,
      responseData.AdressVerantwortung,
      responseData.DefaultProfitCenter,
      responseData.DefaultDepartment,
      responseData.AbsenzFixiert && responseData.AbsenzFixiert === 1 ? true : false,
      responseData.PlanungAufProjekt,
      responseData.DefWebreportTemplate ? responseData.DefWebreportTemplate : 'WebReportReinigung',
      responseData.LohnIntegration
    )
  }
}
